import { render } from "./ResidentialInfo.vue?vue&type=template&id=24061c6e&scoped=true"
import script from "./ResidentialInfo.vue?vue&type=script&lang=js"
export * from "./ResidentialInfo.vue?vue&type=script&lang=js"

import "./ResidentialInfo.vue?vue&type=style&index=0&id=24061c6e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24061c6e"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QTr,QTd,QBtn,QIcon,QPopupProxy,QBanner});
